module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("员工姓名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.employeeName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.departmentName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.job))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职级")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.beforeTurnPositionLevel))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("工号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.employeeNo))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("入职日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.registerTime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("转正申请日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.createFlowDate))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("转正类型")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.turnoverTypeName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("第一阶段试用起止时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.firstStageDate))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("第二阶段试用起止时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.secondStageDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("员工自评")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("员工述职总结报告")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.finalReport))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("本人对本职工作的意见")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.workSuggestion))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("部门意见")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("建议同意该员工")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.auditChoose))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("考核结论")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.optionASumCount))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("转正工资")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.positiveCost))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("转正时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.positiveDate2))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("转正后职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.laterTurnJod))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("转正后职级")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.positionLevel))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("用人部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.employeeDepartment))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("用人单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.companyName))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-664568e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/hr/regular.vue
// module id = UtRu
// module chunks = 1